module.exports = __webpack_public_path__ + "img/touxiang@2x.c9ac30b4.png";